import DealerError from './DealerError.js'

export class ContactDealerError extends DealerError {}
